const PACKAGE_IMAGES = {
  "1round": "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=800&q=80",
  "2rounds": "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80",
  "3rounds": "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=800&q=80",
  "4rounds": "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?w=800&q=80",
  "5rounds": "https://images.unsplash.com/photo-1611374243147-44a702c2d44c?w=800&q=80",
  custom: "https://images.unsplash.com/photo-1593111774240-d529f12cf4bb?w=800&q=80",
};

const estimatePrice = (rounds, nights) => rounds * 90 + nights * 100;

const featuresFor = (rounds, nights) => {
  const list = [
    `${rounds} Round${rounds > 1 ? "s" : ""}, 18 Holes of Golf`,
    "2-Way Ferry & Express Clearance",
    "Land Transfer & Concierge Service",
  ];
  if (nights > 0) list.push(`${nights} Night${nights > 1 ? "s" : ""} Accommodation`);
  return list;
};

export const GOLF_GETAWAY_PACKAGES = [
  {
    id: "1round",
    title: "1 Round",
    tagline: "Day Trip Getaway — Escape for the ultimate golf day trip and be back in time for dinner.",
    duration: "1 Day - 0 Nights",
    rounds: 1,
    nights: 0,
    price: estimatePrice(1, 0),
    destination: "Batam, Indonesia",
    image: PACKAGE_IMAGES["1round"],
    features: featuresFor(1, 0),
  },
  {
    id: "2rounds",
    title: "2 Rounds",
    tagline: "Weekend Golf Getaway — A short escape with two rounds of golf and a night to unwind in Batam.",
    duration: "2 Days - 1 Night",
    rounds: 2,
    nights: 1,
    price: estimatePrice(2, 1),
    destination: "Batam, Indonesia",
    image: PACKAGE_IMAGES["2rounds"],
    features: featuresFor(2, 1),
  },
  {
    id: "3rounds",
    title: "3 Rounds",
    tagline: "Golf Weekend Escape — Three rounds across our finest Batam courses, with two nights to relax between tee times.",
    duration: "3 Days - 2 Nights",
    rounds: 3,
    nights: 2,
    price: estimatePrice(3, 2),
    destination: "Batam, Indonesia",
    image: PACKAGE_IMAGES["3rounds"],
    features: featuresFor(3, 2),
  },
  {
    id: "4rounds",
    title: "4 Rounds",
    tagline: "Extended Golf Getaway — Four rounds of golf paired with three nights of rest, ideal for a proper golfing holiday.",
    duration: "4 Days - 3 Nights",
    rounds: 4,
    nights: 3,
    price: estimatePrice(4, 3),
    destination: "Batam, Indonesia",
    image: PACKAGE_IMAGES["4rounds"],
    features: featuresFor(4, 3),
  },
  {
    id: "5rounds",
    title: "5 Rounds",
    tagline: "Ultimate Golf Retreat — Five rounds across every course we offer, the complete Batam golfing experience.",
    duration: "5 Days - 4 Nights",
    rounds: 5,
    nights: 4,
    price: estimatePrice(5, 4),
    destination: "Batam, Indonesia",
    image: PACKAGE_IMAGES["5rounds"],
    features: featuresFor(5, 4),
  },
  {
    id: "custom",
    title: "Build Your Own",
    tagline: "Custom Golf Package — Choose your own number of rounds, courses and length of stay, built entirely around you.",
    duration: "Flexible",
    rounds: null,
    nights: null,
    custom: true,
    price: estimatePrice(3, 2),
    destination: "Batam, Indonesia",
    image: PACKAGE_IMAGES.custom,
    features: [
      "Choose 1-6 Rounds of Golf",
      "2-Way Ferry & Express Clearance",
      "Land Transfer & Concierge Service",
      "Accommodation Included (if overnight)",
    ],
  },
];
